"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var numBarsToShow = 8;
var MINT_INVENTORY_CONDITION = 'mint-inventory';
var ConditionDisplay = /** @class */ (function (_super) {
    tslib_1.__extends(ConditionDisplay, _super);
    function ConditionDisplay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ConditionDisplay.prototype, "conditionClass", {
        get: function () {
            if (this.props.slug === MINT_INVENTORY_CONDITION) {
                return 'condition-indicator condition-indicator--mint';
            }
            return "condition-indicator condition-indicator--" + this.props.slug;
        },
        enumerable: true,
        configurable: true
    });
    ConditionDisplay.prototype.renderTooltip = function () {
        if (!this.props.showTooltip) {
            return false;
        }
        return ({
            'data-tooltip-text': I18n.t("commons.specList.conditions." + this.props.slug),
            'data-tooltip-align': this.props.alignTooltip,
        });
    };
    ConditionDisplay.prototype.renderBars = function () {
        var bars = [];
        for (var i = 0; i < numBarsToShow; i++) {
            bars.push(React.createElement("span", { key: i }));
        }
        return bars;
    };
    ConditionDisplay.prototype.render = function () {
        if (!this.props.displayName) {
            return null;
        }
        return (React.createElement("div", tslib_1.__assign({ className: this.conditionClass }, this.renderTooltip()),
            React.createElement("div", { className: "condition-indicator__label" }, this.props.displayName),
            React.createElement("div", { className: "condition-indicator__bars" }, this.renderBars())));
    };
    return ConditionDisplay;
}(React.Component));
exports.default = ConditionDisplay;
//# sourceMappingURL=condition_display.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/condition_display.js
// module id = ijaX
// module chunks = 20 21